import { EquipmentMasterThemeSizeConfig } from './types';

const small: EquipmentMasterThemeSizeConfig = {
  equipmentMaster: {},
};

export default small;
